export enum UserRecordType {
    SystemAdministrator = 1
}